import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css'
import { AuthProvider } from "./components/AuthContext";
import { AppDetailsDrawerProvider } from "./components/AppDetailsDrawerContext";
import { PipelineProvider } from "./contexts/PipelineContext";
import { HomeComponent } from "./components/HomeComponent";
import { ProtectedRoute } from './components/ProtectedRoute';
import OktaLogin from './components/OktaLoginComponent';
// PipelineProvider imported from contexts


const App: React.FC = () => {

  return (
    <AuthProvider>
      <PipelineProvider>
        <BrowserRouter>
          <AppDetailsDrawerProvider>
            <Routes>
              <Route path="/signin" element={<OktaLogin />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Routes>
                      <Route path='/*' element={<HomeComponent />} />
                      <Route path='/home/deployment' element={<HomeComponent />} />
                      <Route path='/home/errors' element={<HomeComponent />} />
                    </Routes>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AppDetailsDrawerProvider>
        </BrowserRouter>
      </PipelineProvider>
    </AuthProvider>
  )
}

export default App
